import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { CheckCheck } from 'lucide-react';
export const DeliverInfo = ({ chatEvent }) => {
    if (chatEvent.event_type === 'user_message') {
        const time = new Date(chatEvent.created_at);
        return (_jsxs("div", { className: "text-foreground-muted ml-auto flex items-center gap-2 px-1 text-xs", children: [_jsx("span", { className: cn('bottom-2 inline-flex'), children: chatEvent.delivered_at && (_jsx(_Fragment, { children: _jsx(CheckCheck, { size: 16, color: chatEvent.read_at
                                ? 'var(--color-successful)'
                                : 'var(--color-foreground-muted)' }) })) }), _jsx("span", { className: "whitespace-nowrap uppercase", children: `${time.toLocaleTimeString([], {
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true,
                    })}` })] }));
    }
    throw new Error("Shouldn't be reachable");
};
